// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__27wbq","contentDark":"content_contentDark__1MRRS content_content__27wbq","myCheckbox":"content_myCheckbox__2uiMM page_myInput__1J3mS"};